import React from "react";
import { Stack, TextField, MenuItem } from "@mui/material";

export default function PDCAFilter({ filters, onFilterChange }) {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <TextField
        select
        label="Owner"
        value={filters.owner}
        onChange={(event) => onFilterChange("owner", event.target.value)}
        size="small"
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Alice">Alice</MenuItem>
        <MenuItem value="Bob">Bob</MenuItem>
        <MenuItem value="Charlie">Charlie</MenuItem>
        <MenuItem value="Dana">Dana</MenuItem>
        <MenuItem value="Eve">Eve</MenuItem>
      </TextField>
    </Stack>
  );
}
